
import { getCourtList , getCaseStatusList , getaAreementList ,getStagesScheme ,getProductName ,getFenQiClass,getApplicationType,
    getMediateNumberList} from "@/api/czManager/czCaseInfo/index";
export default {
    namespaced: true,
    state:{
        courtList: [],
        areementList:[],
        caseStatus:[],
        stagesScheme:[],
        productName:[],
        fenQi:[],
        applicationType:[],
        mediateNumberList:[]
    },  
    mutations: {
       getSyncCourtList (state) {
        //    发送请求后获取数据进行保存
            // if(state.courtList == []){
                getCourtList().then((response)=>{
                    state.courtList = response
               })
            // }    
        },
        getSyncCaseStatus(state){
            // if(state.caseStatus == []){
                getCaseStatusList().then((response)=>{
                    state.caseStatus = response
               })
            // }
        
        },
        getAgreement(state){
            // if(state.areementList == []){
                getaAreementList().then((response)=>{
                    state.areementList = response
               })
            // }
         
        },
        getStagesScheme(state){
            // if(state.stagesScheme == []){
                getStagesScheme().then((response)=>{
                   
                    state.stagesScheme = response
               })
            // }
      
        } ,
        getProductName(state){
            // if(state.productName == []){
                getProductName().then(response=>{
                    state.productName = response
                })
            // }
            
        },
        getFenQiClass(state){
                getFenQiClass().then(response=>{
                    state.fenQi= response
                })
        },
        getApplicationType(state){
            getApplicationType().then(response=>{
                    state.applicationType = response
            })
        },
        getMediateNumberList(state){
            getMediateNumberList().then(response=>{
                    state.mediateNumberList = response
            })
        }
    },
    actions: {
         getSelectList ({ commit ,state}) {
            return new Promise((resolve, reject) => {
                commit('getSyncCourtList')  
                commit('getSyncCaseStatus')  
                commit('getAgreement') 
                commit('getStagesScheme')
                commit('getProductName')
                commit('getFenQiClass')
                commit('getApplicationType')
                commit('getMediateNumberList')
                // resolve(200)
                let t =  setInterval(function(){
                        if(state.areementList !=[] && state.caseStatus != [] &&  state.courtList!= [] && state.stagesScheme != []
                            && state.productName != [] && state.fenQi != [] && state.applicationType !=[] && state.mediateNumberList !=[]){
                                clearInterval(t)
                                resolve(200)
                        }
                },1000)
            })
   
             
        },
       
    }
}